module.exports = __webpack_public_path__ + "img/solution28801.1ec3fac2.png";